import { useState, useCallback } from "react";
import { getCotizacionesByEstados } from "../../services/CotizacionService.js";

const useCotizaciones = (baseUrl, idUsuario, estados, setLoading) => {
  const [cotizaciones, setCotizaciones] = useState(null);
  const [loading2, setLoading2] = useState(false);

  const getCotizaciones = useCallback(async () => {
    try {
      setLoading(true);
      setLoading2(true);

      const data = await getCotizacionesByEstados(baseUrl, idUsuario, estados);
      if (Array.isArray(data.cotizaciones)) {
        setCotizaciones(data.cotizaciones);
      } else {
        console.error("Data.cotizaciones no es array:", data.cotizaciones);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoading2(false);
    }
  }, [baseUrl, idUsuario, estados, setLoading]);

  return { cotizaciones, setCotizaciones, loading2, getCotizaciones };
};

export default useCotizaciones;
